'use strict';

/**
 * Pict-Provider-TestRunStepAPI
 * ----------------------------
 * Browser-side CRUD client for TestRunStep, extending the generic EntityAPI
 * provider. Rows are created server-side by POST /1.0/TestRun/Start (the
 * snapshot); the client lists them per run and updates Outcome/Notes as the
 * tester works through the steps. Tenancy (IDCustomer) is enforced
 * server-side, so the client never sends it.
 */

const libPictProviderEntityAPI = require('./Pict-Provider-EntityAPI.js');
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'TestRunStepAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/',
	EntityName: 'TestRunStep',
	PluralRoute: 'TestRunSteps',
	IDField: 'IDTestRunStep'
};

class PictProviderTestRunStepAPI extends libPictProviderEntityAPI
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultProviderConfiguration, pOptions || {}), pServiceHash);
	}

	/**
	 * The snapshot steps of one test run, sorted by SortOrder ascending.
	 * @param {number|string} pIDTestRun - the test run id
	 * @returns {Promise<Array<object>>}
	 */
	listForRun(pIDTestRun)
	{
		let tmpFilter = 'FBV~IDTestRun~EQ~' + pIDTestRun;
		return libFrameworkClient.getJSON(this.fable, this._url(this.pluralRoute + '/FilteredTo/' + tmpFilter + '/0/250'))
			.then((pBody) => Array.isArray(pBody) ? pBody : (pBody && pBody.Records) || [])
			.then((pRows) => pRows.sort((pA, pB) => (Number(pA.SortOrder) || 0) - (Number(pB.SortOrder) || 0)))
			.catch(() => []);
	}
}

module.exports = PictProviderTestRunStepAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;
